import { render, staticRenderFns } from "./mobile-login-footer.vue?vue&type=template&id=8dd4b744&scoped=true&"
import script from "./mobile-login-footer.vue?vue&type=script&lang=js&"
export * from "./mobile-login-footer.vue?vue&type=script&lang=js&"
import style0 from "./mobile-login-footer.vue?vue&type=style&index=0&id=8dd4b744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4b744",
  null
  
)

export default component.exports